import { Locale } from '../types';
import { es } from './spanish';
import { fr } from './french';
import { no } from './norwegian';
import { ro } from './romanian';
import { nl } from './dutch';
import { publicTranslations, translateDynamicUi } from './publicTranslations';
import { observerTranslations, translateObserverDynamic } from './observerTranslations';

const uk: Record<string, string> = {
  'Add': 'Додати',
  'Add user to favorites': 'Додати користувача в обране',
  'All time': 'За весь час',
  'Around the point you selected': 'Навколо обраної точки',
  'Around the visible map area': 'У видимій області мапи',
  'Back to map': 'Назад до мапи',
  'Back to sign in': 'Назад до входу',
  'Cancel manual location placement': 'Скасувати ручний вибір місця',
  'Community map': 'Мапа спільноти',
  'Connecting to your device’s location signal…': 'Підключаємося до геолокації пристрою…',
  'Could not get your current location.': 'Не вдалося отримати ваше поточне місце.',
  'Could not save this location. Please try again.': 'Не вдалося зберегти це місце. Спробуйте ще раз.',
  'Create account': 'Створити обліковий запис',
  'Creating account…': 'Створюємо обліковий запис…',
  'Dark Mode': 'Темна тема',
  'Enable location': 'Увімкнути геолокацію',
  'End': 'Кінець',
  'Failed to get location': 'Не вдалося отримати місце',
  'Failed to load application statistics.': 'Не вдалося завантажити статистику застосунку.',
  'Failed to load map activity.': 'Не вдалося завантажити активність на мапі.',
  'Failed to load statuses': 'Не вдалося завантажити статуси',
  'Favorite person': 'Обрана людина',
  'Favorite user': 'Додати користувача в обране',
  'Find a person in direct messages': 'Знайти людину в особистих повідомленнях',
  'Find a person…': 'Знайти людину…',
  'Getting location…': 'Отримуємо місце…',
  'Hide password': 'Сховати пароль',
  'Hide statuses': 'Сховати статуси',
  'Home': 'Головна',
  'Join the map': 'Приєднатися до мапи',
  'Last day': 'Останній день',
  'Last month': 'Останній місяць',
  'Last week': 'Останній тиждень',
  'Light Mode': 'Світла тема',
  'Like': 'Подобається',
  'Liked': 'Вподобано',
  'Live location sharing is active.': 'Поширення поточного місця активне.',
  'Load older messages': 'Завантажити старіші повідомлення',
  'Loading older messages…': 'Завантажуємо старіші повідомлення…',
  'Manual location is active.': 'Ручне місце активне.',
  'Map friend': 'Друг на мапі',
  'My statuses': 'Мої статуси',
  'Nearby person': 'Людина поруч',
  'Nearby statuses': 'Статуси поруч',
  'New people': 'Нові люди',
  'No nearby stories in this area yet': 'У цій області ще немає історій поруч',
  'No statuses found': 'Статусів не знайдено',
  'No stories shared yet': 'Історій ще немає',
  'People and statuses could not be refreshed. Your current map view is still available.': 'Не вдалося оновити людей і статуси. Поточна мапа залишається доступною.',
  'Place a manual location': 'Вказати місце вручну',
  'Profile': 'Профіль',
  'Reconnecting people and nearby stories…': 'Відновлюємо людей та історії поруч…',
  'Refresh map': 'Оновити мапу',
  'Remove': 'Видалити',
  'Remove user from favorites': 'Видалити користувача з обраного',
  'Reply': 'Відповісти',
  'Save': 'Зберегти',
  'Saved': 'Збережено',
  'Saving…': 'Зберігаємо…',
  'Search all direct messages': 'Шукати в усіх особистих повідомленнях',
  'Search all messages…': 'Шукати в усіх повідомленнях…',
  'Search failed': 'Пошук не вдався',
  'Searching…': 'Шукаємо…',
  'Selected avatar': 'Обраний аватар',
  'Sending…': 'Надсилаємо…',
  'Set a manual location': 'Вказати місце вручну',
  'Set here': 'Вказати тут',
  'Set my location here': 'Вказати моє місце тут',
  'Set your map location to make this status discoverable nearby.': 'Вкажіть місце на мапі, щоб цей статус могли знайти поруч.',
  'Setting your location…': 'Встановлюємо ваше місце…',
  'Share Status': 'Поділитися статусом',
  'Shared from the map': 'Поширено з мапи',
  'Sharing…': 'Публікуємо…',
  'Show password': 'Показати пароль',
  'Show status location on map': 'Показати місце статусу на мапі',
  'Signing in…': 'Входимо…',
  'Someone': 'Хтось',
  'Start a conversation': 'Почати розмову',
  'Status details': 'Деталі статусу',
  'That status is no longer available.': 'Цей статус більше недоступний.',
  'The map is not ready yet.': 'Мапа ще не готова.',
  'The point you selected on the map will be attached to this status.': 'Обрану на мапі точку буде додано до цього статусу.',
  "This user hasn't posted any statuses yet": 'Цей користувач ще не публікував статусів',
  'Time span': 'Проміжок часу',
  'Unable to get your location': 'Не вдалося отримати ваше місце',
  'Unfavorite user': 'Видалити користувача з обраного',
  'Unknown User': 'Невідомий користувач',
  'Unlike': 'Скасувати вподобання',
  'User details': 'Дані користувача',
  'User information not available': 'Інформація про користувача недоступна',
  'View statuses': 'Переглянути статуси',
  'Waiting for a precise device location…': 'Очікуємо точне місце пристрою…',
  'What should nearby people know?': 'Що варто знати людям поруч?',
  'What’s happening around you?': 'Що відбувається навколо вас?',
  'What’s happening, and when?': 'Що й коли відбувається?',
  'What’s the vibe, and where?': 'Який настрій і де?',
  'You': 'Ви',
  'Your current map location will be attached so nearby people can discover it.': 'Ваше поточне місце на мапі буде додано, щоб люди поруч могли знайти допис.',
  'Your location': 'Ваше місце',
  'Your map location': 'Ваше місце на мапі',
  'Close about mapbl': 'Закрити інформацію про mapbl',
  'Close cluster details': 'Закрити деталі групи',
  'Close create status dialog': 'Закрити створення статусу',
  'Close details': 'Закрити деталі',
  'Close direct messages': 'Закрити особисті повідомлення',
  'Close favorites': 'Закрити обране',
  'Close map actions': 'Закрити дії мапи',
  'Close map details': 'Закрити деталі мапи',
  'Close menu': 'Закрити меню',
  'Close notifications': 'Закрити сповіщення',
  'Close panel': 'Закрити панель',
  'Close search': 'Закрити пошук',
  'Close statistics': 'Закрити статистику',
  'Close status': 'Закрити статус',
  'Close statuses dialog': 'Закрити список статусів',
  'Close user profile': 'Закрити профіль користувача',
  'Close user settings': 'Закрити налаштування користувача',
  'Dismiss about mapbl': 'Сховати інформацію про mapbl',
  'Dismiss create status dialog': 'Сховати створення статусу',
  'Dismiss error': 'Сховати помилку',
  'Dismiss map pulse': 'Сховати пульс мапи',
  'Dismiss my statuses': 'Сховати мої статуси',
  'Dismiss nearby statuses': 'Сховати статуси поруч',
  'Dismiss profile settings': 'Сховати налаштування профілю',
  'Dismiss status error': 'Сховати помилку статусу',
  'Dismiss welcome message': 'Сховати привітання',
  'Opening your map…': 'Відкриваємо вашу мапу…',
  'Checking your map identity…': 'Перевіряємо ваш профіль на мапі…',
  'Actions for this map point': 'Дії для цієї точки на мапі',
  'Avatar crop zoom': 'Масштаб кадрування аватара',
  'Avatar image URL': 'URL зображення аватара',
  'Changes to this policy': 'Зміни до цієї політики',
  'Effective September 7, 2026': 'Чинна з 7 вересня 2026 року',
  'Enter your display name': 'Введіть ім’я для показу',
  'Frame your avatar': 'Кадруйте свій аватар',
  'From': 'Від',
  'Here · 50 m': 'Тут · 50 м',
  'How information is used': 'Як використовується інформація',
  'How people will see you': 'Як вас бачитимуть люди',
  'Information used by the game': 'Інформація, яку використовує гра',
  'JPEG, PNG, or GIF up to 5 MB.': 'JPEG, PNG або GIF до 5 МБ.',
  'Map content is not verified. Treat every status, identity, and location as fictional game content—not fact.': 'Вміст мапи не перевіряється. Сприймайте кожен статус, образ і місце як вигаданий ігровий вміст, а не як факт.',
  'Maps and service providers': 'Мапи й постачальники сервісів',
  'Move the map until the target is over the right place.': 'Рухайте мапу, доки позначка не опиниться над потрібним місцем.',
  'OpenStreetMap copyright and attribution': 'Авторські права та атрибуція OpenStreetMap',
  'mapbl is a fantasy experience for fun.': 'mapbl — це фантазійна розвага.',
  'mapbl version': 'Версія mapbl',
  'mapbl is a playful social map where you can share what is happening, discover nearby statuses, and see the community come alive around you.': 'mapbl — це грайлива соціальна мапа, де можна ділитися подіями, знаходити статуси поруч і бачити життя спільноти навколо.',
  'mapbl is a game and creative social experience. Names, profiles, locations, statuses, events, announcements, and other content shown on the map are user-submitted, are not independently verified, and must not be treated as statements of fact. Everything you see should be understood as fictional, role-play, or fantasy content created for entertainment only.': 'mapbl — це гра й творчий соціальний простір. Імена, профілі, місця, статуси, події, оголошення та інший вміст на мапі додають користувачі; він не перевіряється незалежно й не має сприйматися як факт. Усе побачене є вигаданим, рольовим або фантазійним вмістом лише для розваг.',
  'We process only the information needed to provide the experience: account details you submit, such as your email, display name, bio, avatar, and password in protected hashed form; statuses and reactions you create; a browser-selected or manually selected map location; and sign-in tokens stored on your device. This information is saved only so the game can operate and remember your account and game activity.': 'Ми обробляємо лише дані, потрібні для роботи сервісу: надані вами дані облікового запису, зокрема електронну пошту, ім’я, опис, аватар і пароль у захищеному хешованому вигляді; створені статуси й реакції; місце, визначене браузером або вибране вручну; і токени входу на вашому пристрої. Ці дані зберігаються лише для роботи гри та запам’ятовування вашого облікового запису й активності.',
  'Submitted information is used only to authenticate you, display and personalize the map, show game content, support nearby discovery, and maintain the service. mapbl does not sell your personal information or use your game activity to make real-world claims about you.': 'Надані дані використовуються лише для автентифікації, відображення й персоналізації мапи, показу ігрового вмісту, пошуку поруч і підтримки сервісу. mapbl не продає особисті дані й не використовує ігрову активність для тверджень про вас у реальному світі.',
  'The experience is built around a shared map. Your chosen game identity, avatar, bio, approximate or selected location, statuses, and reactions may be visible to other players. Your password and authentication tokens are not displayed to other players. Do not use real-world secrets, sensitive personal details, or a precise real-world location in your public game content.': 'Сервіс побудовано навколо спільної мапи. Обраний ігровий образ, аватар, опис, приблизне або вибране місце, статуси й реакції можуть бачити інші гравці. Пароль і токени автентифікації їм не показуються. Не додавайте до публічного ігрового вмісту справжні секрети, чутливі особисті дані або точне реальне місце.',
  'The site may rely on hosting, map, and geocoding providers to deliver the service. Those providers may receive ordinary technical requests, such as an IP address and map coordinates, under their own privacy terms. We limit access to stored information to what is necessary to operate and protect the game.': 'Для роботи сайт може використовувати постачальників хостингу, мап і геокодування. Вони можуть отримувати звичайні технічні запити, як-от IP-адресу та координати мапи, відповідно до власних умов приватності. Ми обмежуємо доступ до збережених даних тим, що необхідно для роботи й захисту гри.',
  'You choose what identity, status, and location to submit. You can update your profile and game content through the available controls, stop sharing a browser location by changing your browser permissions, and sign out to remove sign-in tokens from the device. Please contact the site operator if you need help with your account or stored information.': 'Ви самі обираєте, який образ, статус і місце надсилати. У доступних налаштуваннях можна оновити профіль та ігровий вміст, припинити передачу місця через дозволи браузера й вийти, щоб видалити токени входу з пристрою. Якщо потрібна допомога з обліковим записом або збереженими даними, зверніться до оператора сайту.',
  'We may update this policy as the game changes. The effective date at the top will be revised when that happens. Continued use of mapbl after an update means you accept the revised policy.': 'Ми можемо оновлювати цю політику разом зі змінами гри. У такому разі дата набуття чинності вгорі буде змінена. Продовжуючи користуватися mapbl після оновлення, ви приймаєте переглянуту політику.',
  'About': 'Про застосунок',
  'About mapbl': 'Про mapbl',
  'About the service': 'Про сервіс',
  'Account': 'Обліковий запис',
  'All stories': 'Усі історії',
  'Application statistics': 'Статистика застосунку',
  'Area': 'Область',
  'Back to conversations': 'Назад до розмов',
  'Bio': 'Про себе',
  'Cancel': 'Скасувати',
  'Choose your map position': 'Оберіть свою позицію на мапі',
  'Choose your map vibe': 'Оберіть свій настрій на мапі',
  'Clear': 'Очистити',
  'Community first': 'Спільнота передусім',
  'Connection interrupted': 'З’єднання перервано',
  'Could not locate you': 'Не вдалося визначити ваше місце',
  'Create Status': 'Створити статус',
  'Create an account': 'Створити обліковий запис',
  'Create status': 'Створити статус',
  'Create your identity': 'Створіть свій образ',
  'Crop Current Avatar': 'Обрізати поточний аватар',
  'Direct Messages': 'Особисті повідомлення',
  'Direct messages': 'Особисті повідомлення',
  'Display Name': 'Ім’я для показу',
  'Display name': 'Ім’я для показу',
  'Edit': 'Редагувати',
  'Edit direct message': 'Редагувати особисте повідомлення',
  'Edit reply': 'Редагувати відповідь',
  'Edited': 'Змінено',
  'Email address': 'Електронна пошта',
  'Emoji collections': 'Добірки емодзі',
  'Favorite people or statuses to keep them close.': 'Додавайте людей або статуси в обране, щоб вони були поруч.',
  'Favorites': 'Обране',
  'Filter by status type': 'Фільтр за типом статусу',
  'Filter profile statuses': 'Фільтрувати статуси профілю',
  'Filter the signal': 'Фільтрувати дописи',
  'Finding your location': 'Визначаємо ваше місце',
  'Go to my location': 'Перейти до мого місця',
  'Ignore user': 'Ігнорувати користувача',
  'Ignored users': 'Ігноровані користувачі',
  'Jump to latest messages': 'Перейти до останніх повідомлень',
  'Last 24 hours': 'Останні 24 години',
  'Last hour': 'Остання година',
  'Link (optional)': 'Посилання (необов’язково)',
  'Live community signal': 'Живий пульс спільноти',
  'Live map stories': 'Живі історії на мапі',
  'Load more results': 'Завантажити більше',
  'Load older': 'Завантажити старіші',
  'Load older replies': 'Завантажити старіші відповіді',
  'Loading favorites…': 'Завантажуємо обране…',
  'Loading ignored users…': 'Завантажуємо ігнорованих користувачів…',
  'Loading messages…': 'Завантажуємо повідомлення…',
  'Loading replies…': 'Завантажуємо відповіді…',
  'Loading statuses': 'Завантажуємо статуси',
  'Loading user data...': 'Завантажуємо дані користувача…',
  'Loading…': 'Завантаження…',
  'Locating you': 'Визначаємо ваше місце',
  'Location needs attention': 'Потрібна увага до геолокації',
  'Make it yours': 'Налаштуйте під себе',
  'Map': 'Мапа',
  'Map avatar preview': 'Попередній перегляд аватара',
  'Map discovery': 'Пошук на мапі',
  'Map navigation': 'Навігація мапою',
  'Map pulse': 'Пульс мапи',
  'Map refresh paused': 'Оновлення мапи призупинено',
  'Mark all read': 'Позначити все прочитаним',
  'Message': 'Повідомлення',
  'Message *': 'Повідомлення *',
  'Messages': 'Повідомлення',
  'My Location': 'Моє місце',
  'My Statuses': 'Мої статуси',
  'Nearby Statuses': 'Статуси поруч',
  'Nearby activity': 'Активність поруч',
  'Nearby radius': 'Радіус поруч',
  'New status': 'Новий статус',
  'No matching messages found.': 'Відповідних повідомлень не знайдено.',
  'No notifications yet': 'Сповіщень ще немає',
  'No people found in your direct messages.': 'У ваших особистих повідомленнях нікого не знайдено.',
  'Nothing shared in this cluster yet': 'У цій групі ще нічого не опубліковано',
  'Notifications': 'Сповіщення',
  'Notification settings': 'Налаштування сповіщень',
  'Number of statuses': 'Кількість статусів',
  'Observe nearby statuses': 'Переглядайте статуси поруч',
  'Open shared link': 'Відкрити посилання',
  'Password': 'Пароль',
  'People': 'Люди',
  'People and statuses you saved': 'Збережені люди та статуси',
  'People make the map': 'Люди створюють мапу',
  'Post a new status or message here': 'Опублікувати тут новий статус або повідомлення',
  'Posted': 'Опубліковано',
  'Privacy & play': 'Приватність і гра',
  'Privacy Policy': 'Політика приватності',
  'Private conversation': 'Особиста розмова',
  'Private conversations': 'Особисті розмови',
  'Profile settings': 'Налаштування профілю',
  'Reading the map pulse…': 'Зчитуємо пульс мапи…',
  'Ready to upload': 'Готово до завантаження',
  'Recent': 'Нещодавні',
  'Recent searches': 'Нещодавні пошуки',
  'Refresh': 'Оновити',
  'Refresh statuses': 'Оновити статуси',
  'Refreshing the map': 'Оновлюємо мапу',
  'Reload mapbl': 'Перезавантажити mapbl',
  'Replies and direct messages': 'Відповіді та особисті повідомлення',
  'Reply to status': 'Відповісти на статус',
  'Say hello to start the conversation.': 'Привітайтеся, щоб почати розмову.',
  'Search a wider area': 'Шукати на більшій території',
  'Search every message in your direct conversations.': 'Шукайте в усіх повідомленнях ваших особистих розмов.',
  'Select a conversation to read your messages.': 'Оберіть розмову, щоб прочитати повідомлення.',
  'Selected map point': 'Обрана точка на мапі',
  'Selected period': 'Обраний період',
  'Send direct message': 'Надіслати особисте повідомлення',
  'Settings': 'Налаштування',
  'Share nearby': 'Поділитися поруч',
  'Short bio': 'Коротко про себе',
  'Show': 'Показати',
  'Sign in': 'Увійти',
  'Sign in to mapbl': 'Увійти в mapbl',
  'Start must be before end.': 'Початок має бути раніше за кінець.',
  'Status reply': 'Відповідь на статус',
  'Statuses': 'Статуси',
  'Stop ignoring': 'Припинити ігнорування',
  'Surprise me': 'Здивувати мене',
  'Surprise me with an emoji': 'Здивувати мене емодзі',
  'The map hit a rough patch': 'На мапі сталася помилка',
  'Time': 'Час',
  'Time filter': 'Фільтр часу',
  'Time span end': 'Кінець проміжку часу',
  'Time span start': 'Початок проміжку часу',
  'To': 'До',
  'Toggle menu': 'Відкрити або закрити меню',
  'Try again': 'Спробувати ще раз',
  'Unread': 'Непрочитане',
  'Updated': 'Оновлено',
  'Use a photo': 'Використати фото',
  'Use an image URL instead': 'Натомість використати URL зображення',
  'Use emoji': 'Використати емодзі',
  'Use this crop': 'Використати це кадрування',
  'What are you sharing?': 'Чим ви ділитеся?',
  'Width': 'Ширина',
  'Write a direct message': 'Написати особисте повідомлення',
  'Write a message…': 'Напишіть повідомлення…',
  'Write a reply…': 'Напишіть відповідь…',
  'You are not ignoring anyone.': 'Ви нікого не ігноруєте.',
  'Your map identity': 'Ваш образ на мапі',
  'Your password': 'Ваш пароль',
  'Your recent posts and moments': 'Ваші нещодавні дописи й моменти',
  'You’re on the map': 'Ви на мапі',
  'Zoom': 'Масштаб',
  'edited': 'змінено',
  'latest': 'останніх',
  'optional': 'необов’язково',
  'or set it manually on the map': 'або вкажіть вручну на мапі',
  'statuses': 'статусів',
  'sent you a message': 'надіслав(-ла) вам повідомлення',
  'replied to your status': 'відповів(-ла) на ваш статус',
  'Just now': 'Щойно',
  'Statuses (': 'Статуси (',
  'Users (': 'Користувачі (',
  'people ·': 'людей ·',
  'Failed to update profile': 'Не вдалося оновити профіль',
  'Failed to upload avatar': 'Не вдалося завантажити аватар',
  'Failed to log out': 'Не вдалося вийти',
  'Please select a valid image file (JPEG, PNG, GIF)': 'Оберіть коректний файл зображення (JPEG, PNG або GIF)',
  'File size must be less than 5MB': 'Розмір файлу має бути меншим за 5 МБ',
  'Failed to load current avatar image for cropping': 'Не вдалося завантажити поточний аватар для кадрування',
  'Geolocation is not supported by this browser': 'Цей браузер не підтримує геолокацію',
  'Geolocation is not supported by this browser.': 'Цей браузер не підтримує геолокацію.',
  'Location permission denied': 'Доступ до геолокації заборонено',
  'Location permission denied. Please enable location access in your browser settings.': 'Доступ до геолокації заборонено. Увімкніть його в налаштуваннях браузера.',
  'Location request timed out. Please try again.': 'Час очікування геолокації минув. Спробуйте ще раз.',
  'Location tracking failed': 'Не вдалося відстежувати місце',
  'Location tracking timed out': 'Час очікування відстеження місця минув',
  'Location unavailable': 'Місце недоступне',
  'Location unavailable. Please check your GPS or network connection.': 'Місце недоступне. Перевірте GPS або мережеве з’єднання.',
  'A fantasy map made for fun': 'Фантазійна мапа для розваг',
  'A little about you': 'Трохи про себе',
  'A quick look at how the community is moving.': 'Швидкий погляд на активність спільноти.',
  'Bright, friendly, and a little futuristic.': 'Яскраво, дружньо й трохи футуристично.',
  'Choose a photo or an upbeat emoji. This is how people recognize you on the map.': 'Оберіть фото або позитивний емодзі — так люди впізнаватимуть вас на мапі.',
  'Choose how long new live locations and statuses animate on the map.': 'Оберіть, як довго нові місця в реальному часі та статуси анімуватимуться на мапі.',
  'Choose someone on the map to start a conversation.': 'Оберіть когось на мапі, щоб почати розмову.',
  'Drag to position, then fine-tune the zoom.': 'Перетягніть для позиціювання, а потім налаштуйте масштаб.',
  'Find the bright moments happening around you.': 'Знаходьте яскраві моменти навколо.',
  'Share a location, leave a status, and discover the people and energy nearby.': 'Діліться місцем, залишайте статус і відкривайте людей та події поруч.',
  'Sign out of mapbl on this device.': 'Вийти з mapbl на цьому пристрої.',
  'Tell us about yourself': 'Розкажіть про себе',
  'Their locations, statuses, and direct messages are hidden both ways.': 'Ваші місця, статуси й особисті повідомлення взаємно приховані.',
  'What other players can see': 'Що бачать інші гравці',
  'Your choices': 'Ваш вибір',
  '5 seconds': '5 секунд',
  '10 seconds': '10 секунд',
  'A quick heads-up': 'Коротке сповіщення',
  'Recommended': 'Рекомендовано',
  'Never': 'Ніколи',
  'Keep markers still': 'Не рухати маркери',
  'Until I open it': 'Поки я не відкрию',
  'Animate until selected': 'Анімувати до вибору',
  'Uploading…': 'Завантаження…',
  'Upload avatar': 'Завантажити аватар',
  'Logging out…': 'Виходимо…',
  'Logout': 'Вийти',
  'Updating…': 'Оновлення…',
  'Update Profile': 'Оновити профіль',
  'Language': 'Мова',
  'Interface language': 'Мова інтерфейсу',
  'English': 'Англійська',
  'Ukrainian': 'Українська',
  'Spanish': 'Іспанська',
  'French': 'Французька',
  'Norwegian': 'Норвезька',
  'Dutch': 'Нідерландська',
  'Romanian': 'Румунська',
  'Profile updated successfully!': 'Профіль успішно оновлено!',
  'Avatar uploaded successfully!': 'Аватар успішно завантажено!',
  'Welcome back': 'З поверненням',
  'Your map, people, and nearby moments are waiting.': 'Ваша мапа, люди й моменти поруч уже чекають.',
  'New to mapbl?': 'Вперше в mapbl?',
  'Already on mapbl?': 'Уже користуєтеся mapbl?',
  'Password is required': 'Введіть пароль',
  'Email is required': 'Введіть електронну пошту',
  'Enter a valid email address': 'Введіть коректну електронну адресу',
  'At least 6 characters': 'Щонайменше 6 символів',
  'Your account and map data are safe. Reload mapbl to reconnect and pick up where you left off.': 'Ваш обліковий запис і дані мапи в безпеці. Перезавантажте mapbl, щоб продовжити.',
};

const ukPatterns: Array<[RegExp, (match: RegExpMatchArray) => string]> = [
  [/^(\d+)m ago$/, (m) => `${m[1]} хв тому`],
  [/^(\d+)h ago$/, (m) => `${m[1]} год тому`],
  [/^(\d+)d ago$/, (m) => `${m[1]} дн тому`],
  [/^Updated (.+)$/, (m) => `Оновлено ${m[1]}`],
  [/^Edited (.+)$/, (m) => `Змінено ${m[1]}`],
  [/^Ignore (.+)$/, (m) => `Ігнорувати ${m[1]}`],
  [/^Close (.+)$/, (m) => `Закрити: ${m[1]}`],
  [/^Dismiss (.+)$/, (m) => `Сховати: ${m[1]}`],
];

const esPatterns: Array<[RegExp, (match: RegExpMatchArray) => string]> = [
  [/^(\d+)m ago$/, (m) => `hace ${m[1]} min`],
  [/^(\d+)h ago$/, (m) => `hace ${m[1]} h`],
  [/^(\d+)d ago$/, (m) => `hace ${m[1]} d`],
  [/^Updated (.+)$/, (m) => `Actualizado ${m[1]}`],
  [/^Edited (.+)$/, (m) => `Editado ${m[1]}`],
  [/^Ignore (.+)$/, (m) => `Ignorar a ${m[1]}`],
  [/^Close (.+)$/, (m) => `Cerrar: ${m[1]}`],
  [/^Dismiss (.+)$/, (m) => `Ocultar: ${m[1]}`],
];

const frPatterns: Array<[RegExp, (match: RegExpMatchArray) => string]> = [
  [/^(\d+)m ago$/, (m) => `il y a ${m[1]} min`],
  [/^(\d+)h ago$/, (m) => `il y a ${m[1]} h`],
  [/^(\d+)d ago$/, (m) => `il y a ${m[1]} j`],
  [/^Updated (.+)$/, (m) => `Mis à jour ${m[1]}`],
  [/^Edited (.+)$/, (m) => `Modifié ${m[1]}`],
  [/^Ignore (.+)$/, (m) => `Ignorer ${m[1]}`],
  [/^Close (.+)$/, (m) => `Fermer : ${m[1]}`],
  [/^Dismiss (.+)$/, (m) => `Masquer : ${m[1]}`],
];

const noPatterns: Array<[RegExp, (match: RegExpMatchArray) => string]> = [
  [/^(\d+)m ago$/, (m) => `${m[1]} min siden`],
  [/^(\d+)h ago$/, (m) => `${m[1]} t siden`],
  [/^(\d+)d ago$/, (m) => `${m[1]} d siden`],
  [/^Updated (.+)$/, (m) => `Oppdatert ${m[1]}`],
  [/^Edited (.+)$/, (m) => `Redigert ${m[1]}`],
  [/^Ignore (.+)$/, (m) => `Ignorer ${m[1]}`],
  [/^Close (.+)$/, (m) => `Lukk: ${m[1]}`],
  [/^Dismiss (.+)$/, (m) => `Skjul: ${m[1]}`],
];

const roPatterns: Array<[RegExp, (match: RegExpMatchArray) => string]> = [
  [/^(\d+)m ago$/, (m) => `acum ${m[1]} min`],
  [/^(\d+)h ago$/, (m) => `acum ${m[1]} h`],
  [/^(\d+)d ago$/, (m) => `acum ${m[1]} ${m[1] === '1' ? 'zi' : 'zile'}`],
  [/^Updated (.+)$/, (m) => `Actualizat ${m[1]}`],
  [/^Edited (.+)$/, (m) => `Editat ${m[1]}`],
  [/^Ignore (.+)$/, (m) => `Ignoră ${m[1]}`],
  [/^Close (.+)$/, (m) => `Închide: ${m[1]}`],
  [/^Dismiss (.+)$/, (m) => `Închide: ${m[1]}`],
];

const nlPatterns: Array<[RegExp, (match: RegExpMatchArray) => string]> = [
  [/^(\d+)m ago$/, (m) => `${m[1]} min geleden`],
  [/^(\d+)h ago$/, (m) => `${m[1]} uur geleden`],
  [/^(\d+)d ago$/, (m) => `${m[1]} d geleden`],
  [/^Updated (.+)$/, (m) => `Bijgewerkt ${m[1]}`],
  [/^Edited (.+)$/, (m) => `Bewerkt ${m[1]}`],
  [/^Ignore (.+)$/, (m) => `${m[1]} negeren`],
  [/^Close (.+)$/, (m) => `Sluiten: ${m[1]}`],
  [/^Dismiss (.+)$/, (m) => `Verbergen: ${m[1]}`],
];

export const translate = (text: string, locale: Locale): string => {
  if (locale === 'en') return text;
  const catalog = locale === 'es' ? es : locale === 'fr' ? fr : locale === 'no' ? no : locale === 'ro' ? ro : locale === 'nl' ? nl : uk;
  if (catalog[text]) return catalog[text];
  if (publicTranslations[locale][text]) return publicTranslations[locale][text];
  if (observerTranslations[locale][text]) return observerTranslations[locale][text];
  const observerDynamic = translateObserverDynamic(text, locale);
  if (observerDynamic) return observerDynamic;
  const dynamicUi = translateDynamicUi(text, locale);
  if (dynamicUi) return dynamicUi;
  const patterns = locale === 'es' ? esPatterns : locale === 'fr' ? frPatterns : locale === 'no' ? noPatterns : locale === 'ro' ? roPatterns : locale === 'nl' ? nlPatterns : ukPatterns;
  for (const [pattern, formatter] of patterns) {
    const match = text.match(pattern);
    if (match) return formatter(match);
  }
  return text;
};
